module.exports = __webpack_public_path__ + "static/media/eufy.26546cc8.jpeg";